export default __webpack_public_path__ + "static/media/HCS2021_program-abstracts_2021-11-10.1a6f90ae.pdf";